import { render } from "./SynonymsBox.vue?vue&type=template&id=25681130&scoped=true"
import script from "./SynonymsBox.vue?vue&type=script&lang=js"
export * from "./SynonymsBox.vue?vue&type=script&lang=js"

import "./SynonymsBox.vue?vue&type=style&index=0&id=25681130&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25681130"

export default script